var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex align-items-center justify-content-center",class:[_setup.additionalClasses]},[_c('BaseLoaderAffility',{attrs:{"isXmasMode":_vm.$config.xmasMode,"duration":_setup.duration,"width":_setup.width,"height":_setup.height}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }